import { normalizeUrl } from '../../utils/url';
function calculateIsINPeventDuringNavigation(inpStartTime, navigationParams) {
    if (!navigationParams) {
        return undefined;
    }
    if (navigationParams.isDuringNavigation) {
        return true;
    }
    if (!navigationParams.lastNavigationTimings) {
        return undefined;
    }
    const { start: navigationStart, end: navigationEnd } = navigationParams.lastNavigationTimings;
    return navigationStart && navigationEnd
        ? inpStartTime >= navigationStart && inpStartTime <= navigationEnd
        : undefined;
}
const getEventTarget = ({ attribution: { processedEventEntries, interactionTarget }, }) => {
    let target = processedEventEntries.length > 0
        ? processedEventEntries[0]?.target
        : undefined;
    /**
     * There is a bug in Chrome due to which it sometimes would not report target for some events:
     * https://bugs.chromium.org/p/chromium/issues/detail?id=1367329
     * This is handled in web-vitals library by trying to find the target from the entries and exposing it's selector:
     * https://github.com/GoogleChrome/web-vitals/pull/421
     * While selector is exposed, the target itself is not, so we need to find it from the entries, similarly to what they do in the extension:
     * https://github.com/GoogleChrome/web-vitals-extension/pull/168/files#diff-a828877823604a91a1a9b7d31dc0c83c85d70e627780a93cf2934e0cc1dbe053
     */
    if (!target && interactionTarget) {
        target = processedEventEntries.find((entry) => entry.target)?.target;
    }
    return target;
};
export const toInpMetric = (metric, getHtmlElementMetadata) => {
    const { value, attribution: { interactionTime, interactionTarget, interactionType, loadState, inputDelay, processingDuration, presentationDelay, nextPaintTime, longAnimationFrameEntries, }, } = metric;
    const htmlElementMetadata = getHtmlElementMetadata(getEventTarget(metric) || null);
    const navigationParams = htmlElementMetadata.navigationParams;
    const inpIsDuringNavigation = calculateIsINPeventDuringNavigation(interactionTime, navigationParams);
    return {
        inpValue: Math.trunc(value),
        inpUrl: normalizeUrl(window.location.href),
        inpRating: metric.rating,
        //TODO: rename inpEventType to inpInteractionType in event schema
        inpEventType: interactionType,
        inpTargetSelector: interactionTarget,
        inpStartTime: interactionTime ? Math.trunc(interactionTime) : undefined,
        inpInputDelay: inputDelay,
        inpProcessingDuration: processingDuration,
        inpPresentationDelay: presentationDelay,
        inpLoadState: loadState,
        inpNextPaintTime: nextPaintTime,
        inpComponentType: htmlElementMetadata.compType,
        inpWidgetId: htmlElementMetadata.widgetId,
        inpApplicationId: htmlElementMetadata.applicationId,
        inpIsDuringNavigation,
        inpLoafs: JSON.stringify(longAnimationFrameEntries),
    };
};
//# sourceMappingURL=inp.js.map